import { api } from './api';

export * from './types';

export const {
  useLoginMutation,
  useLogoutMutation,
  usePasswordRequestMutation,
  usePasswordResetMutation,
  useRegisterMutation,
  useAcceptInvitationMutation,
  useVerifyUserMutation,
  useRequestTokenMutation,
  useRequestInviteTokenMutation,
  useTrackInviteIpMutation,
  useUpdateMeMutation,
} = api;

export * from './middlewares';

export { api };
